import { useHudStore, useSystemStore } from '../store/sceneStore';

export const AutonomousStop = () => {
	const system = useSystemStore();
	const hud = useHudStore();
	return (
		system.status === '⛔' &&
		hud.mode === 'AUTONOMOUS' && (
			<div
				id='popup-overlay'
				class='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 p-4'
			>
				<div
					id='popup-content'
					class='flex h-auto w-11/12 flex-col items-center justify-center space-y-4 rounded-2xl bg-white/80 p-6 text-center shadow-2xl backdrop-blur-sm sm:space-y-6 sm:p-8 md:w-2/3 lg:max-w-xl'
				>
					<div class='relative flex h-24 w-32 items-center justify-center'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							class='animate-driveAndStop absolute z-10 h-20 w-20 text-gray-800'
							viewBox='0 0 24 24'
							fill='none'
							stroke='currentColor'
							stroke-width='2'
							stroke-linecap='round'
							stroke-linejoin='round'
						>
							<path d='M14 16H9m10 0h1.5a2.5 2.5 0 0 0 0-5H19l-1.8-4.4A2 2 0 0 0 15.4 5H8.6a2 2 0 0 0-1.8 2.6L5 11H3.5a2.5 2.5 0 0 0 0 5H5' />
							<circle cx='7.5' cy='16.5' r='1.5' />
							<circle cx='16.5' cy='16.5' r='1.5' />
						</svg>

						<div class='absolute -top-2 right-0 z-20 rounded-full bg-white p-1 shadow'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								class='h-10 w-10 text-orange-500'
								viewBox='0 0 24 24'
								fill='currentColor'
							>
								<path d='M12.866 3.464a2 2 0 0 0-1.732 0L3.464 7.134a2 2 0 0 0-1 1.732v7.268a2 2 0 0 0 1 1.732l7.67 4.666a2 2 0 0 0 1.732 0l7.67-4.666a2 2 0 0 0 1-1.732V8.866a2 2 0 0 0-1-1.732L12.866 3.464zM11 15h2v2h-2v-2zm0-8h2v6h-2V7z' />
							</svg>
						</div>
					</div>

					<h2 class='text-2xl font-bold text-gray-800 sm:text-3xl'>
						시스템이 정차하고 있습니다.
					</h2>

					<p class='max-w-md text-sm text-gray-600 sm:text-base'>
						이상 상태가 감지되었습니다. 확인 후 주행하세요.
					</p>
				</div>
			</div>
		)
	);
};
